module.exports = __webpack_public_path__ + "static/img/13.38c0864.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/zh/13.png
// module id = RtjY
// module chunks = 0